module.exports = __webpack_public_path__ + "img/new_color_pngs@2x.309748ae.png";